import useMediaViewerNavigation from '@/components/composite/MediaViewer/hooks/useMediaViewerNavigation';

import PropTypes from 'prop-types';

import { POST, STORY } from '@/lib/posts/postTypes';

import Modal from '@/components/base/Modal';
import MediaViewerContent from '@/components/composite/MediaViewer/MediaViewerContent';
import MediaViewerNavigation from '@/components/composite/MediaViewer/MediaViewerNavigation';

const ModalContent = ({
    mediaId,
    mediasList = [],
    mediaType = POST,
    group,
    socialProfile,
    mediaRequestParams = {},
    mutateMedias,
    defaultTabsIndex,
    onLoadMore,
    hasMore = false,
    isLoadingMore = false
}) => {
    const {
        media,
        previousMedia,
        nextMedia,
        currentContentState,
        currentNetworkType,
        isLoading,
        mutateMedia,
        goToMedia,
        getNavMediaNetworkType,
        hasNavigation,
        showNextNav,
        isNextNavDisabled
    } = useMediaViewerNavigation({
        mediaId,
        mediasList,
        mediaType,
        group,
        socialProfile,
        mediaRequestParams,
        onLoadMore,
        hasMore,
        isLoadingMore
    });

    return (
        <Modal.Body className="w-full">
            {hasNavigation && (
                <MediaViewerNavigation
                    post={previousMedia}
                    postType={mediaType}
                    isLoading={isLoading}
                    socialNetworkType={getNavMediaNetworkType(previousMedia)}
                    navAction={() => goToMedia(previousMedia)}
                    className="btn-mv-nav-prev"
                />
            )}
            <MediaViewerContent
                post={media}
                postType={mediaType}
                socialProfile={currentContentState.socialProfile}
                socialNetworkType={currentNetworkType}
                socialNetworkId={currentContentState.socialProfile?.id}
                isLoading={isLoading}
                hasNavigation={hasNavigation}
                mutateMedia={mutateMedia}
                mutateMedias={mutateMedias}
                defaultTabsIndex={defaultTabsIndex}
            />
            {hasNavigation && showNextNav && (
                <MediaViewerNavigation
                    post={nextMedia}
                    postType={mediaType}
                    isLoading={isLoading}
                    disabled={isNextNavDisabled}
                    socialNetworkType={getNavMediaNetworkType(nextMedia)}
                    navAction={() => goToMedia(nextMedia)}
                    isNext={true}
                    className="btn-mv-nav-next"
                />
            )}
        </Modal.Body>
    );
};

ModalContent.propTypes = {
    mediaId: PropTypes.string,
    mediasList: PropTypes.arrayOf(PropTypes.object),
    mediaType: PropTypes.oneOf([POST, STORY]),
    group: PropTypes.object,
    socialProfile: PropTypes.object,
    mediaRequestParams: PropTypes.object,
    mutateMedias: PropTypes.func,
    defaultTabsIndex: PropTypes.number,
    onLoadMore: PropTypes.func,
    hasMore: PropTypes.bool,
    isLoadingMore: PropTypes.bool
};

const MediaViewerModal = ({
    isOpen,
    toggle,
    mediaId,
    mediasList = [],
    group,
    socialProfile,
    mediaType = POST,
    mediaRequestParams = {},
    mutateMedias,
    defaultTabsIndex = 0,
    onLoadMore,
    hasMore = false,
    isLoadingMore = false
}) => {
    return (
        <Modal size="full" open={isOpen} onDismiss={toggle}>
            <ModalContent
                mediaId={mediaId}
                mediasList={mediasList}
                mediaType={mediaType}
                group={group}
                socialProfile={socialProfile}
                mediaRequestParams={mediaRequestParams}
                mutateMedias={mutateMedias}
                defaultTabsIndex={defaultTabsIndex}
                onLoadMore={onLoadMore}
                hasMore={hasMore}
                isLoadingMore={isLoadingMore}
            />
        </Modal>
    );
};

MediaViewerModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mediaId: PropTypes.string,
    mediasList: PropTypes.arrayOf(PropTypes.object),
    group: PropTypes.object,
    socialProfile: PropTypes.object,
    mediaType: PropTypes.oneOf([POST, STORY]),
    mediaRequestParams: PropTypes.object,
    mutateMedias: PropTypes.func,
    defaultTabsIndex: PropTypes.number,
    onLoadMore: PropTypes.func,
    hasMore: PropTypes.bool,
    isLoadingMore: PropTypes.bool
};

export default MediaViewerModal;
